import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import instantChatIcon1 from "../../images/v4/linkGeneration/icons/instantChatIcon1.svg";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import darkGreenCheck from "../../images/v4/industry/education/icons/darkGreenCheck.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import transformBackgroundImage from "../../images/v4/linkGeneration/images/transformBackgroundImage.png";

import partnerSectionBackground from "../../images/v4/linkGeneration/images/partnerSectionBackground.png";

import bestPracticeIcon1 from "../../images/v4/industry/realState/icons/bestPracticeIcon1.svg";
import bestPracticeIcon2 from "../../images/v4/industry/realState/icons/bestPracticeIcon2.svg";
import bestPracticeIcon3 from "../../images/v4/industry/realState/icons/bestPracticeIcon3.svg";
import bestPracticeIcon4 from "../../images/v4/industry/realState/icons/bestPracticeIcon4.svg";
import bestPracticeIcon5 from "../../images/v4/industry/realState/icons/bestPracticeIcon5.svg";
import bestPracticeIcon6 from "../../images/v4/industry/realState/icons/bestPracticeIcon6.svg";

import gridIcon1 from "../../images/v4/industry/realState/icons/gridIcon1.svg";
import gridIcon2 from "../../images/v4/industry/realState/icons/gridIcon2.svg";
import gridIcon3 from "../../images/v4/industry/realState/icons/gridIcon3.svg";
import gridIcon4 from "../../images/v4/industry/realState/icons/gridIcon4.svg";
import gridIcon5 from "../../images/v4/industry/realState/icons/gridIcon5.svg";
import gridIcon6 from "../../images/v4/industry/realState/icons/gridIcon6.svg";
import gridIcon7 from "../../images/v4/industry/realState/icons/gridIcon7.svg";

import bestPracticeBg from "../../images/v4/industry/education/images/bestPracticeBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/realState/images/compareItemImg5.png";

import featureSectionImg from "../../images/v4/industry/realState/images/featureSectionImg.png";
import meaningImg from "../../images/v4/industry/realState/images/meaningImg.png";
import benifitImg from "../../images/v4/industry/realState/images/benifitImg.png";
import bodySectionBg from "../../images/v4/industry/education/images/bodySectionBg.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "90px 0 220px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "300px",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(0deg, #002C51 0%, #208EEC 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  pills: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    // marginTop: "25px",
  },
  pill: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "30px",
    border: "1px solid #CEE9FF",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
      "& img": {
        width: "20px",
      },
    },
  },
  experienceContainerHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    gap: "20px",
    "& h2": {
      width: "55%",
    },
    "& p": {
      width: "45%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "100%",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    paddingBottom: "300px",
    paddingTop: "260px",
    "& .container:first-child": {
      padding: "30px 0",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-460px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "500px",
      paddingBottom: "240px",
      "& .container:first-child": {
        padding: "30px 15px",
      },
    },
  },
  gridSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "40px",
    },
  },
  gridRow: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "&.row1": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "&.row2": {
      "& $gridCard": {
        width: "32%",
      },
    },
    "&.row3": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  gridCard: {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    background: "#ffffff1a",
    borderRadius: "16px",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    gap: "16px",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bestPracticeBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      paddingBottom: "170px",
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "24px",
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "75%",
    "@media only screen and (max-width: 600px)": {
      top: "91%",
    },
  },
  stripSection: {
    paddingTop: "280px",
    backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "180px",
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #7C35B5 0%, #672A99 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& $supportBox": {
        top: "-830px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  featureSection: {
    padding: "20px 0",
    background: "#F5FAFF",
  },
  featureSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  featureContainerLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  featureContainerRight: {
    width: "50%",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& $cardPointer": {
      alignItems: "flex-start",
      "& img": {
        position: "relative",
        top: "5px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        position: "relative",
        top: "5px",
        width: "20px",
      },
    },
  },
  wpFaq: {
    // padding: "40px 0",
    "& $faqSection": {
      padding: 0,
    },
    background: "#F1FFF9",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  // testimonials: {
  //   paddingBottom: "40px",
  // },
}));

const RealEstateIndustry = () => {
  const classes = useStyles();
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "How to use CRM for real estate?",
      answer: (
        <>
          Pepper Cloud CRM can be used to manage contacts, track leads, automate
          follow-ups, manage property listings, and analyse performance metrics
          to streamline your real estate operations and boost sales.
        </>
      ),
    },
    {
      question: "How is CRM important for realtors?",
      answer: (
        <>
          CRM is crucial for realtors as it helps manage client relationships,
          streamline property listings, automate tasks, and provide data-driven
          insights, ultimately leading to increased sales and client
          satisfaction.
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud CRM suitable for small real estate businesses?",
      answer: (
        <>
          Absolutely! Pepper Cloud CRM is designed to cater to businesses of all
          sizes, offering scalable features and affordable pricing that make it
          an excellent choice for small real estate businesses looking to grow.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud CRM help with lead generation?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers lead capture webtools, web forms, and
          integrations with popular lead gen platforms to help you generate and
          manage leads effectively.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud CRM AI-powered chatbot work?",
      answer: (
        <>
          The AI chatbot can handle common client queries, provide property
          information, and even schedule viewings, improving response times and
          freeing up your team to focus on high-value tasks.
        </>
      ),
    },
  ];
  const features1 = [
    {
      icon: gridIcon1,
      alt: "",
      heading: "Comprehensive contact management",
      desc: "Easily organise and track all client interactions, property preferences, and communication history in one centralised database.",
    },
    {
      icon: gridIcon2,
      alt: "",
      heading: "Efficient pipeline management",
      desc: "Visualise and optimise your sales pipeline, from initial lead capture to closing deals, ensuring no opportunity slips through the cracks.",
    },
  ];
  const features2 = [
    {
      icon: gridIcon3,
      alt: "",
      heading: "Powerful document management",
      desc: "Integrates with Google Drive to securely store and access important documents such as contracts, property listings, etc.",
    },
    {
      icon: gridIcon4,
      alt: "",
      heading: "Omnichannel communication",
      desc: "Engage with clients seamlessly across multiple platforms, including email, calls, and social media, all from a single interface.",
    },
    {
      icon: gridIcon5,
      alt: "",
      heading: "Automated follow-ups and reminders",
      desc: "Set up time and event-based workflow automation to nurture leads and stay on top of important tasks and deadlines.",
    },
  ];
  const features3 = [
    {
      icon: gridIcon6,
      alt: "",
      heading: "AI-powered insights",
      desc: "Leverage artificial intelligence to gain valuable insights into market trends, client preferences, and sales forecasts.",
    },
    {
      icon: gridIcon7,
      alt: "",
      heading: "Customisable dashboards",
      desc: "Tailor your CRM interface to display the most relevant information for your real estate business, enhancing productivity and decision-making.",
    },
  ];
  const bestPractice = [
    {
      icon: bestPracticeIcon1,
      alt: "",
      heading: "Easy lead capture",
      desc: "Capture leads using in-built web forms, website chat widget, lead forms, etc. and send instant follow-ups.",
    },
    {
      icon: bestPracticeIcon2,
      alt: "",
      heading: "Segment your database",
      desc: "Group contacts based on criteria like budget, preferred location, and property type for targeted marketing.",
    },
    {
      icon: bestPracticeIcon3,
      alt: "",
      heading: "Personalise communications",
      desc: "Use students and parents data to tailor emails, messages, and counselling recommendations.",
    },
    {
      icon: bestPracticeIcon4,
      alt: "",
      heading: "Maintain updated listings",
      desc: "Keep your data updated with the latest property details and ensure it keeps updating in real-time.",
    },
    {
      icon: bestPracticeIcon5,
      alt: "",
      heading: "Implement lead scoring",
      desc: "Prioritise leads based on engagement and likelihood to convert. Automate the process to cut down repetitive tasks.",
    },
    {
      icon: bestPracticeIcon6,
      alt: "",
      heading: "Keep records up to date",
      desc: "Ensure student profiles, documents, and application statuses are always updated in real-time.",
    },
  ];
  const compareItems = [
    "Pepper Cloud ",
    "HubSpot",
    "Salesforce",
    "Zoho ",
    "Realvolve",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM emerges as the top choice for real estate professionals and property developers. This comprehensive solution offers a perfect blend of robust features and user-friendly interface, tailored specifically for the real estate industry. With its powerful contact management, pipeline tracking, and AI-driven insights, Pepper Cloud empowers real estate businesses to streamline operations, nurture leads effectively, and close deals faster.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Contact management",
          desc: "Centralise all client information, interactions, and property preferences in one intuitive platform.",
        },
        {
          title: "Pipeline management",
          desc: "Visualise and optimise your sales pipeline from lead capture to closing deals.",
        },
        {
          title: "Document management",
          desc: "Securely store and access property listings, contracts, and client agreements with ease.",
        },
        {
          title: "Omnichannel communication",
          desc: "Engage clients seamlessly across multiple platforms, including email, SMS, and social media.",
        },
        {
          title: "AI-powered chatbot",
          desc: "Provide instant support and information to potential buyers, improving response times and lead qualification.",
        },
        {
          title: "Mobile accessibility",
          desc: "Manage your real estate business on-the-go with a feature-rich mobile app for iOS and Android.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot offers a versatile CRM platform that can be adapted for real estate businesses. While not specifically designed for the property sector, its robust marketing and sales features make it a solid choice for realtors looking to align their marketing and sales efforts.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Email marketing",
          desc: "Create and send targeted email campaigns to nurture leads.",
        },
        {
          title: "Meeting scheduler",
          desc: "Simplify property viewing appointments with an integrated scheduling tool.",
        },
        {
          title: "Deal tracking",
          desc: "Monitor the progress of property deals through various stages.",
        },
        {
          title: "Reporting dashboard",
          desc: "Access detailed analytics to track performance and identify areas for improvement.",
        },
      ],
    },
    {
      title: "Salesforce Real Estate Cloud",
      desc: "Salesforce Real Estate Cloud is a powerful, customisable solution designed for larger real estate operations. It offers extensive features but may require significant setup and customisation.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Property management",
          desc: "Comprehensive tools for managing property listings and details.",
        },
        {
          title: "Advanced analytics",
          desc: "In-depth reporting and forecasting capabilities.",
        },
        {
          title: "Customer 360",
          desc: "Gain a complete view of client interactions across all touchpoints.",
        },
        {
          title: "AppExchange",
          desc: "Access a wide range of real estate-specific add-ons and integrations.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers a cost-effective solution for small to medium-sized real estate businesses. Its user-friendly interface and customisation options make it a good choice for those new to CRM systems",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Lead scoring",
          desc: "Automatically prioritise leads based on their likelihood to convert.",
        },
        {
          title: "Workflow automation",
          desc: "Streamline repetitive tasks and improve team efficiency.",
        },
        {
          title: "Social media integration",
          desc: "Monitor and engage with potential clients across various social platforms.",
        },
        {
          title: "Mobile app",
          desc: "Manage client relationships and property listings on-the-go.",
        },
      ],
    },
    {
      title: "Realvolve CRM",
      desc: "Realvolve is a real estate-specific CRM designed with workflows and relationship management in mind. While it's less robust compared to industry-leading solutions, it's a good fit for individual agents and small teams who want a balance of simplicity and customisation.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Workflow automation",
          desc: "Pre-built and custom workflows for transactions and marketing.",
        },
        {
          title: "Contact timelines",
          desc: "Track past and future interactions with clients.",
        },
        {
          title: "Email templates",
          desc: "Use branded templates for consistent communication.",
        },
        {
          title: "Integration support",
          desc: "Connects with tools like Google Calendar, Gmail, and Zapier.",
        },
      ],
    },
  ];
  const industryFeature = [
    {
      title: "Assess your specific needs",
      desc: "Identify the key challenges your real estate business faces and prioritise features.",
    },
    {
      title: "Consider scalability",
      desc: "Choose a CRM that can grow with your business, offering additional features and capacity.",
    },
    {
      title: "Evaluate integration capabilities",
      desc: "Ensure the CRM integrates with your existing tools, such as listing platforms.",
    },
    {
      title: "Check for mobile accessibility",
      desc: "Opt for a CRM with a mobile app, essential for agents who are often out of the office.",
    },
    {
      title: "Analyse reporting features",
      desc: "Look for comprehensive analytics and reporting tools to gain insights into market trends and business performance.",
    },
  ];
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <main>
      <SEO
        title={"Best Real Estate CRM for Property Developers | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/industry/best-real-estate-crm-for-property-developers/"
        }
        keywords="crm for real estate and property developers, real estate crm software, best crm software real estate, crm for real estate developers"
        description={
          "The best CRM for real estate businesses is designed for property developers, builders and brokers. Manage field visits, track your agents, automate tasks and more."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },

          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "How to use CRM for real estate?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM can be used to manage contacts, track leads, automate follow-ups, manage property listings, and analyse performance metrics to streamline your real estate operations and boost sales.",
                },
              },
              {
                "@type": "Question",
                name: "How is CRM important for realtors?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM is crucial for realtors as it helps manage client relationships, streamline property listings, automate tasks, and provide data-driven insights, ultimately leading to increased sales and client satisfaction.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for small real estate businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! Pepper Cloud CRM is designed to cater to businesses of all sizes, offering scalable features and affordable pricing that make it an excellent choice for small real estate businesses looking to grow.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud CRM help with lead generation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM offers lead capture webtools, web forms, and integrations with popular lead gen platforms to help you generate and manage leads effectively.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM AI-powered chatbot work?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The AI chatbot can handle common client queries, provide property information, and even schedule viewings, improving response times and freeing up your team to focus on high-value tasks.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-18"
              style={{ color: "#0291AE" }}
            >
              Real estate
            </motion.h1>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              The best real estate CRM software
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Revolutionise your real estate business with Pepper Cloud CRM, the
              all-in-one solution designed to streamline operations and boost
              sales for property professionals.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Centralised platform for real estate
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Automate follow-ups and reminders
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Mobile CRM for on-the-go access
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link className="primaryButton font-20 font-wix-medium font-white">
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What is a real estate CRM?
              </p>
              <p
                className="font-18 font-inter-regular"
                style={{ color: "#BEE7E7" }}
              >
                A real estate CRM system is a specialised software solution
                designed to help property professionals manage client
                relationships, streamline sales processes, and organise property
                listings. It centralises contact information, property details,
                and communication history, enabling real estate agents and
                property developers to provide personalised service.
              </p>
              <div className={classes.pills}>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    AI-powered
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    WhatsApp capabilities
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    Easy to use
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={meaningImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className={classes.experienceContainerHeader}>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is the best CRM for real estate?
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18"
              style={{ color: "#A2BED3" }}
            >
              Built for real estate developers and agencies, property
              developers, brokerage firms, etc. of all sizes, Pepper Cloud, the
              top CRM for real estate boosts sales, streamlines property
              management, and accelerates process end-to-end.
            </motion.p>
          </div>
          <div className={classes.gridSection}>
            <div className={clsx(classes.gridRow, "row1")}>
              {features1.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row2")}>
              {features2.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row3")}>
              {features3.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.alt} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What are the benefits of using real estate CRM software?
              </p>
              <div className={classes.pointers}>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Enhanced client relationships: Maintain detailed records of
                    client interactions, preferences, and property interests.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Streamlined lead management: Capture, track, and nurture
                    leads effectively, ensuring no potential client falls
                    through cracks.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Improved time management: Automate repetitive tasks and set
                    auto-reminders for follow-ups, viewings, and more.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Centralised information hub: Store property listings, client
                    details, and transaction information and other details in a
                    single platform.
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benifitImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM for real estate and property developers in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.featureSection}>
        <div className="container">
          <div className={classes.featureSectionContainer}>
            <div className={classes.featureContainerLeft}>
              <LazyImage source={featureSectionImg} width={"100%"} alt={""} />
            </div>
            <div className={classes.featureContainerRight}>
              <p className="font-wix-medium font-40 color-black1">
                How to choose the best real estate CRM software
              </p>
              <div className={classes.pointers}>
                {industryFeature.map((point) => (
                  <div className={classes.cardPointer}>
                    <LazyImage source={darkGreenCheck} alt={"pointer"} />
                    <p className="font-18 font-inter-regular color-black1">
                      {point.title}: {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Real estate CRM software: Best practices
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.alt} />
                <p className="font-wix-semibold font-24 font-black1">
                  {practice.heading}
                </p>
                <p className="font-wix-medium font-16 font-black1">
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#F1FFF9"}
          heading={"FAQs - best real estate CRM software"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Manage leads and listings easily with best real estate CRM
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default RealEstateIndustry;
